import { Injectable } from '@angular/core';

/**
 * Meta Pixel page views for the single-page app. The pixel itself is loaded in index.html, which sends one
 * PageView for the first load; after that the app changes screens without reloading the page, so each screen
 * change is sent from here. Does nothing where the pixel is not loaded (localhost) and never throws.
 */
@Injectable({ providedIn: 'root' })
export class MetaPixelService {
  private firstNavigationSeen = false;
  private lastPath = '';

  /** Call on every finished navigation with its final URL. */
  pageView(url: string): void {
    const path = String(url || '').split('?')[0].split('#')[0];
    // The first navigation is the page load itself, which index.html already counted.
    if (!this.firstNavigationSeen) {
      this.firstNavigationSeen = true;
      this.lastPath = path;
      return;
    }
    // A query-only change (?preview, ?page=…) is the same screen.
    if (path === this.lastPath) return;
    this.lastPath = path;
    try {
      const fbq = (window as any).fbq;
      if (typeof fbq === 'function') fbq('track', 'PageView');
    } catch { /* tracking is best-effort */ }
  }
}
